(function () {
  var MOVE_THRESHOLD = 12;

  function bindImageTap(opener) {
    var button = opener.querySelector('.product__media-toggle:not(.product__media-zoom-none)');
    if (!button || opener.dataset.tapBound === 'true') return;

    opener.dataset.tapBound = 'true';
    var startX = 0;
    var startY = 0;
    var moved = false;

    opener.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        moved = false;
      },
      { passive: true }
    );

    opener.addEventListener(
      'touchmove',
      function (e) {
        var touch = e.touches[0];
        if (
          Math.abs(touch.clientX - startX) > MOVE_THRESHOLD ||
          Math.abs(touch.clientY - startY) > MOVE_THRESHOLD
        ) {
          moved = true;
        }
      },
      { passive: true }
    );

    opener.addEventListener('touchend', function (e) {
      if (!moved) {
        e.preventDefault();
        button.click();
      }
    });

    opener.addEventListener('click', function (e) {
      if (e.target === button || button.contains(e.target)) return;
      button.click();
    });
  }

  function initImageTap() {
    document.querySelectorAll('.product__modal-opener--image').forEach(bindImageTap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageTap);
  } else {
    initImageTap();
  }

  document.addEventListener('shopify:section:load', initImageTap);
})();
